import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import Title from '../title/Title';
import SearchWrapper from '../search_wrapper/SearchWrapper';
import { shopsActions } from '../../actions';
import {
  entriesSelector, viewAllShopsSelector,
  defaultShopsSelector, directionModeSelector,
} from '../../selectors/shops';
import ContentSelector from '../content_selector/ContentSelector';
import RequestGeolocation from '../../services/geolocation';
import api from '../../api';
import MapWithStores from '../map_with_stores/MapWithStores';
import StoresList from '../stores_list/StoresList';
import AllStores from '../all_stores/AllStores';
import styles from './Shops.module.sass';

const DESKTOP_WIDTH_BREAKPOINT = 700;
class Shops extends React.PureComponent {
  componentDidMount() {
    const {
      setUserAddress, setSearchQuery, shopsLoadRequest,
      assignDefaultData, defaultData,
    } = this.props;

    assignDefaultData(defaultData);

    RequestGeolocation().then((position) => {
      const params = [position.coords.latitude, position.coords.longitude];
      api.getAddress(params).then((response) => {
        // 204 when the coordinates don't reverse-geocode; keep the default list.
        if (!response.data) { return; }

        setUserAddress(response.data);
        setSearchQuery(response.data);
        shopsLoadRequest(response.data);
      });
    });
  }

  desktopTitleText = () => {
    const { directionMode, viewAllShops } = this.props;

    if (directionMode) { return 'Directions'; }
    if (viewAllShops) { return 'Complete Store List'; }
    return 'Find A Store Near You';
  };

  render() {
    const { defaultShops } = this.props;

    if (defaultShops.length === 0) return null;
    return (
      <div className={styles['stores-page-container']}>
        <MediaQuery query={`(max-width: ${DESKTOP_WIDTH_BREAKPOINT - 1}px)`}>
          <Title title="Find a Store Near You" subtitle="Available at Sephora" />
          <SearchWrapper />
          <ContentSelector />
          <MapWithStores />
          <StoresList />
          <AllStores />
        </MediaQuery>
        <MediaQuery query={`(min-width: ${DESKTOP_WIDTH_BREAKPOINT}px)`}>
          <div className={styles['desktop-container']}>
            <div className={styles.left}>
              <h1 className={styles.title}>
                { this.desktopTitleText() }
              </h1>
              <SearchWrapper />
              <StoresList />
            </div>
            <div className={styles.right}>
              <Title title="Available at Sephora" />
              <MapWithStores />
            </div>
          </div>
          <AllStores />
        </MediaQuery>
      </div>
    );
  }
}

Shops.propTypes = {
  defaultData: PropTypes.shape({
    entries: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  assignDefaultData: PropTypes.func.isRequired,
  viewAllShops: PropTypes.bool.isRequired,
  setUserAddress: PropTypes.func.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
  shopsLoadRequest: PropTypes.func.isRequired,
  defaultShops: PropTypes.arrayOf(PropTypes.shape({})),
  directionMode: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  shops: entriesSelector(state),
  viewAllShops: viewAllShopsSelector(state),
  defaultShops: defaultShopsSelector(state),
  directionMode: directionModeSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  shopsLoadRequest: (location) => {
    dispatch(shopsActions.shopsLoadRequest({ location }));
  },
  setUserAddress: (userAddress) => { dispatch(shopsActions.setUserAddress(userAddress)); },
  setSearchQuery: (searchQuery) => { dispatch(shopsActions.setSearchQuery(searchQuery)); },
  assignDefaultData: (data) => { dispatch(shopsActions.assignDefaultData({ data })); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Shops);
